import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Button,
  Checkbox,
  Form,
  Input,
  Row,
  Col,
  Spin,
  message,
  Modal,
} from "antd";
import { useNavigate } from "react-router-dom";
import Smcs_New_Logo from "../../assests/images/Smcs_New_Logo.png";
// import Cookies from "universal-cookie";

import {
  getAccountService,
  loginUser,
} from "../../actionsMethods/cashBookingMethods";

import "antd/dist/antd.css";
import "./index.scss";

const NormalLoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState();
  const [loading, setLoading] = useState(false);

  const getLoginResponse = useSelector(
    (state) => state.appReducer.loginUser,
    shallowEqual
  );

  const getAccountServiceResponse = useSelector(
    (state) => state?.appReducer?.getAccountServiceReducer,
    shallowEqual
  );

  const { error, fetching, result } = getLoginResponse;

  const { fetching: accountFetching, result: accountResult } =
    getAccountServiceResponse;

  useEffect(() => {
    if (getLoginResponse?.result !== null) {
      if (getLoginResponse?.result?.isRegistered) {
        localStorage.setItem(
          "userinfo",
          JSON.stringify(getLoginResponse?.result)
        );
        window.location.replace("/cp-onbording");
      } else {
        navigate("/create-new-password", {
          state: { ...getLoginResponse?.result },
        });
      }

      // navigate("/cp-onbording");
    }
    if (error !== null) {
      message.error(error.message);
    }
  }, [getLoginResponse]);

  // function addHours(date, hours) {
  //   date.setTime(date.getTime() + hours * 60 * 60 * 1000);
  //   return date;
  // }
  // useEffect(() => {
  //   if (result !== null) {
  //     localStorage.setItem("userinfo", JSON.stringify(result));

  //     const object = { name: result.accessToken, email: result.username };
  //     document.cookie = "userToken=" + JSON.stringify(object);
  //     let sec = result?.expiresIn;
  //     let hour = parseInt(sec / 3600);
  //     const result1 = addHours(new Date(), hour);
  //     localStorage.setItem("loggedOutTime", JSON.stringify(result1.getTime()));
  //   } else {
  //     setErrorMessage(error?.message);
  //   }
  // }, [result, error, fetching]);

  // useEffect(() => {
  //   if (result) {
  //     setLoading(true);
  //     dispatch(getAccountService(result?.username, result?.accessToken));
  //   }
  // }, [result]);

  // useEffect(() => {
  //   if (accountResult !== null) {
  //     localStorage.setItem("userId", JSON.stringify(accountResult));
  //     localStorage.setItem(
  //       "userName",
  //       JSON.stringify(accountResult?.userInfo?.firstName)
  //     );
  //     // navigate("/dashboard");
  //     let url = localStorage.getItem("viewClient");
  //     if (url !== undefined && url !== null) {
  //       window.location.replace(url);
  //     } else {
  //       window.location.replace("/dashboard");
  //     }
  //   }
  // }, [getAccountServiceResponse]);

  const onFinish = async (values) => {
    console.log(values);
    delete values.remember;
    dispatch(loginUser(values));
  };

  const handleForgot = () => {
    navigate("/forgotPassword");
  };

  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setModalText("The modal will be closed after two seconds");
    setConfirmLoading(true);
  };
  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  useEffect(() => {
    showModal();
  }, []);

  const payloadData = [
    {
      firstName: "Nagesh",
      lastName: "Nagu",
      dateOfBirth: "04/10/2005",
      contactNumber: "9999607708",
      emailId: "Nagesh@mailinator.com",
      role: "ROLE_HUBDRIVER",
      idType: "DL",
      idUrl:
        "https://s3.ap-south-1.amazonaws.com/smcs-uat/210/DL/smcs_71163904049767.png",
      dlClass: "HMV,MGV,LMV",
      idNumber: "KA32765773399876",
    },
    {
      firstName: "Dheeraj",
      lastName: "Dheer",
      dateOfBirth: "04/10/2005",
      contactNumber: "3486077669",
      emailId: "Dheeraj@mailinator.com",
      role: "ROLE_HUBDRIVER",
      idType: "DL",
      idUrl:
        "https://s3.ap-south-1.amazonaws.com/smcs-uat/210/DL/smcs_71163904049767.png",
      dlClass: "HMV,MGV,LMV",
      idNumber: "KA32765556909546",
    },
  ];

  const newFunction = () => {
    const axios = require("axios");

    // let data = JSON.stringify({
    //   firstName: "Deepesh",
    //   lastName: "Alksdjf",
    //   dateOfBirth: "04/10/2005",
    //   contactNumber: "3486077089",
    //   emailId: "deepesh@mailinator.com",
    //   role: "ROLE_HUBDRIVER",
    //   idType: "DL",
    //   idUrl:
    //     "https://s3.ap-south-1.amazonaws.com/smcs-uat/210/DL/smcs_71163904049767.png",
    //   dlClass: "HMV,MGV,LMV",
    //   idNumber: "KA32765556999876",
    // });
    let result = "200";
    let i = 0;

    do {
      const element = payloadData[i];
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://smcs-uat.hutechweb.com/smcs-webapp/staff-service/v1/staff",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Accept-Language": "en-GB,en-US;q=0.9,en;q=0.8",
          Authorization:
            "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzdWJoYW5rYXIuY2hha3JhYm9ydHlAc2hyZWVtYXJ1dGljb3VyaWVyLmNvbSIsImF1dGhvcml0aWVzIjpbeyJhdXRob3JpdHkiOiJST0xFX0hVQkFETUlOIn1dLCJpc3MiOiJodHRwOi8vc21jcy1kZXYuaHV0ZWNod2ViLmNvbS9zbWNzLXdlYmFwcCIsImp0aSI6IjEzYzIwMWE1LTBkNmUtNDJiYS1iODNhLWU5Mzc2MzQ5OTc1MSIsImlhdCI6MTY5Njg1MTY1MywiZXhwIjoxNjk2ODgwNDUzfQ.8YFvSwXKTCCDRdeSAEXwxbSo349ditebWshVJixG5Uc",
          Connection: "keep-alive",
          "Content-Type": "application/json",
          Cookie:
            '_clck=9kodpy|2|ffk|0|1365; userToken={"name":"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzdWJoYW5rYXIuY2hha3JhYm9ydHlAc2hyZWVtYXJ1dGljb3VyaWVyLmNvbSIsImF1dGhvcml0aWVzIjpbeyJhdXRob3JpdHkiOiJST0xFX0hVQkFETUlOIn1dLCJpc3MiOiJodHRwOi8vc21jcy1kZXYuaHV0ZWNod2ViLmNvbS9zbWNzLXdlYmFwcCIsImp0aSI6IjEzYzIwMWE1LTBkNmUtNDJiYS1iODNhLWU5Mzc2MzQ5OTc1MSIsImlhdCI6MTY5Njg1MTY1MywiZXhwIjoxNjk2ODgwNDUzfQ.8YFvSwXKTCCDRdeSAEXwxbSo349ditebWshVJixG5Uc","email":"subhankar.chakraborty@shreemaruticourier.com"}',
          Origin: "https://smcs-uat.hutechweb.com",
          Referer: "https://smcs-uat.hutechweb.com/staff-onboarding",
          "SMCS-PREMISE-ID": "210",
          "Sec-Fetch-Dest": "empty",
          "Sec-Fetch-Mode": "cors",
          "Sec-Fetch-Site": "same-origin",
          "USER-ID": "2227",
          "User-Agent":
            "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/117.0.0.0 Safari/537.36",
          "sec-ch-ua":
            '"Google Chrome";v="117", "Not;A=Brand";v="8", "Chromium";v="117"',
          "sec-ch-ua-mobile": "?0",
          "sec-ch-ua-platform": '"Windows"',
        },
        data: element,
      };

      i = i + 1;

      axios
        .request(config)
        .then((response) => {
          result = response.data.response.status;
          return response.data;
          // console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          return error;
        });
    } while (i < payloadData.length && result == "200");

    // console.log(result);
    //     let statue = 200;
    //     if (statue)
    //       for (let i = 0; i < payloadData.length; i++) {
    //         const element = [i];
    //         let config = {
    //           method: "post",
    //           maxBodyLength: Infinity,
    //           url: "https://smcs-uat.hutechweb.com/smcs-webapp/staff-service/v1/staff",
    //           headers: {
    //             Accept: "application/json, text/plain, */*",
    //             "Accept-Language": "en-GB,en-US;q=0.9,en;q=0.8",
    //             Authorization:
    //               "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzdWJoYW5rYXIuY2hha3JhYm9ydHlAc2hyZWVtYXJ1dGljb3VyaWVyLmNvbSIsImF1dGhvcml0aWVzIjpbeyJhdXRob3JpdHkiOiJST0xFX0hVQkFETUlOIn1dLCJpc3MiOiJodHRwOi8vc21jcy1kZXYuaHV0ZWNod2ViLmNvbS9zbWNzLXdlYmFwcCIsImp0aSI6IjEzYzIwMWE1LTBkNmUtNDJiYS1iODNhLWU5Mzc2MzQ5OTc1MSIsImlhdCI6MTY5Njg1MTY1MywiZXhwIjoxNjk2ODgwNDUzfQ.8YFvSwXKTCCDRdeSAEXwxbSo349ditebWshVJixG5Uc",
    //             Connection: "keep-alive",
    //             "Content-Type": "application/json",
    //             Cookie:
    //               '_clck=9kodpy|2|ffk|0|1365; userToken={"name":"eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJzdWJoYW5rYXIuY2hha3JhYm9ydHlAc2hyZWVtYXJ1dGljb3VyaWVyLmNvbSIsImF1dGhvcml0aWVzIjpbeyJhdXRob3JpdHkiOiJST0xFX0hVQkFETUlOIn1dLCJpc3MiOiJodHRwOi8vc21jcy1kZXYuaHV0ZWNod2ViLmNvbS9zbWNzLXdlYmFwcCIsImp0aSI6IjEzYzIwMWE1LTBkNmUtNDJiYS1iODNhLWU5Mzc2MzQ5OTc1MSIsImlhdCI6MTY5Njg1MTY1MywiZXhwIjoxNjk2ODgwNDUzfQ.8YFvSwXKTCCDRdeSAEXwxbSo349ditebWshVJixG5Uc","email":"subhankar.chakraborty@shreemaruticourier.com"}',
    //             Origin: "https://smcs-uat.hutechweb.com",
    //             Referer: "https://smcs-uat.hutechweb.com/staff-onboarding",
    //             "SMCS-PREMISE-ID": "210",
    //             "Sec-Fetch-Dest": "empty",
    //             "Sec-Fetch-Mode": "cors",
    //             "Sec-Fetch-Site": "same-origin",
    //             "USER-ID": "2227",
    //             "User-Agent":
    //               "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/117.0.0.0 Safari/537.36",
    //             "sec-ch-ua":
    //               '"Google Chrome";v="117", "Not;A=Brand";v="8", "Chromium";v="117"',
    //             "sec-ch-ua-mobile": "?0",
    //             "sec-ch-ua-platform": '"Windows"',
    //           },
    //           data: element,
    //         };
    //         let res = axios
    //           .request(config)
    //           .then((response) => {
    //             return response.data;
    //             // console.log(JSON.stringify(response.data));
    //           })
    //           .catch((error) => {
    //             return error;
    //           });
    //         console.log(res);
    //       }
  };

  return (
    <div className="login-main-container">
      <Spin spinning={fetching || loading || accountFetching}>
        <Modal
          title="Tutorial links"
          open={open}
          // onOk={handleOk}
          onCancel={handleCancel}
          footer={false}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <div>
              {/* Hindi Tutorial YouTube Link */}
              <a
                href="https://youtu.be/dylxtbTOo5Q"
                target="_blank"
                style={{ fontSize: "21px", color: "#3E257D" }}
              >
                {" "}
                सीपी ऑनबोर्डिंग ट्यूटोरियल हिंदी में{" "}
              </a>
            </div>
            <div>
              <a
                href="https://youtu.be/L7artHInAQA"
                target="_blank"
                style={{ fontSize: "21px", color: "#3E257D" }}
              >
                {" "}
                CP onboarding tutorial in English{" "}
              </a>
            </div>
          </div>

          {/* <div>
            English Tutorial YouTube Link: https://youtu.be/L7artHInAQA{" "}
          </div> */}
        </Modal>
        <Row>
          <Col
            className="img-parent"
            xl={12}
            lg={12}
            md={12}
            sm={0}
            xs={24}
            // className={"logibg-container"}
          >
            <div className="img-div"></div>
          </Col>
          <Col
            xl={12}
            lg={12}
            md={12}
            sm={24}
            xs={24}
            // style={{
            //   margin: "0 auto",
            //   position: "relative",
            //   backgroundColor: " #ffffff",
            // }}
            className="login-parent"
          >
            <div className="login-container">
              <div className="small-screen-logo">
                <img
                  src={Smcs_New_Logo}
                  alt="smcs-logo"
                  className="login-img"
                />
              </div>
              <div className="login-container-headding">
                Login To Your Account
              </div>
              <div className="login-container-subheadding">
                Prompt, Quick & Reliable Services
              </div>
              <div className="error">
                <p>{errorMessage}</p>
              </div>
              <Form
                // style={{ marginTop: "5%" }}
                onFinish={onFinish}
                autoComplete="on"
                initialValues={
                  {
                    // username: "priyaranjan@hutechsolutions.com",
                    // password: "Hutech@1234",
                    // name:"sdhjdhhjs"
                  }
                }
              >
                <div
                  className="login-container-email"
                  style={{ marginTop: 20 }}
                >
                  User Name
                </div>

                <Form.Item
                  name="userName"
                  rules={[
                    {
                      required: true,
                      message: "Enter your email address",
                    },
                  ]}
                >
                  <Input
                    className="login-container-email-input"
                    placeholder="Enter your email address"
                    maxLength={50}
                    bordered={false}
                  />
                </Form.Item>
                <div
                  className="login-container-email"
                  style={{ marginTop: "30px" }}
                >
                  Password
                </div>
                <div>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Enter your password",
                      },
                    ]}
                  >
                    <Input.Password
                      className="login-container-email-input"
                      placeholder="Password"
                      bordered={false}
                    />
                  </Form.Item>
                </div>
                <div className="login-container-remember">
                  <div
                    style={{
                      display: "flex",
                      columnGap: "10px",
                    }}
                  >
                    <Checkbox />
                    <span className="rememberMe">Remember me</span>
                  </div>
                  <div
                    className="login-container-forgot"
                    onClick={handleForgot}
                  >
                    Forgot Password ?
                  </div>
                  {/* <div className="login-container-forgot" onClick={newFunction}>
                    creatData
                  </div> */}
                </div>

                <Form.Item>
                  <div className="login-container-btndiv">
                    {" "}
                    <Button
                      className="login-container-btn"
                      type="primary"
                      size="large"
                      htmlType="submit"
                      block
                    >
                      LOGIN
                    </Button>
                  </div>
                </Form.Item>
              </Form>
              <div
                className="footer"
                style={{
                  position: "sticky",
                  bottom: 0,
                  display: "flex",
                  justifyContent: "center",
                  // border: "2px solid red",
                  // width: "70%",
                }}
              >
                <p>
                  Copyright © {new Date().getFullYear()} Shree Maruti Integrated
                  Logistics Limited
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
  );
};

export default NormalLoginForm;
